<template>
  <div class="d-flex">
    <i
      @click="$emit('selettoreIndietro')"
      @keyup.enter="$emit('selettoreIndietro')"
      class="tasto_back fas fa-arrow-circle-left"
    ></i>

    <div style="margin-left:1vw;">
      <ol v-if="cronologia_selettore.length " class="breadcrumb">
        <li
          :key="step.id"
          @click="$emit('caricaBreadcrumb', {'step': step,'index': index})"
          v-for="(step,index) in cronologia_selettore"
          class="breadcrumb-item capitalized"
        >
          <span>{{step.value}}</span>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { db } from "@/components/Firebase_Conn";
import { storage } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import Vue from "vue";

//<selettoreQuadratino  :items="items" :ricambio="ricambio" :selettore="selettore" :inEdit="inEdit"></selettoreQuadratino>

export default {
  name: "selettoreBreadCrumbs",
  props: ["cronologia_selettore"],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.capitalized {
  text-transform: capitalize;
}

.tasto_back {
  font-size: 2.6vh;
  color: #e5e5e5;
  cursor: pointer;
}


.breadcrumb {
  background-color: initial !important;
  font-size: 1.6vh;
  color: #c2c3c4;

  font-weight: 400;
  font-family: "Font Awesome 5 Free", "Arial" !important;
  margin: 0 !important;
  padding: 0 !important;
}

.breadcrumb > li + li:before {
  font-size: 1.6vh;
  color: white !important;
  content: "" !important;
  padding: 0px !important;
  margin: 0px !important;
  border: 0px !important;
}

.breadcrumb-item {
  cursor: pointer;
  background-color: #f9f9f9;
  margin-left: 1vh;
  padding-left: 2.5vh;
  padding-right: 2.5vh;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.breadcrumb-item:hover {
  color: grey;
}
</style>
